import { render } from "./ViewLocations.vue?vue&type=template&id=2ecec468"
import script from "./ViewLocations.vue?vue&type=script&lang=js"
export * from "./ViewLocations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__